<template>
  <div
    :class="['pdf', 'pdf--' + size]"
    :style="windowWidth < 688 ? false : { height: (height - 16) + 'px' }"
  >
    <div class="pdf__header">
      <div class="pdf__logo">
        <svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" viewBox="0 0 24 24"><path d="M8.847 17.875c.191-.211.548-.431.801-.559-.152.3-.366.619-.544.792-.36.353-.556.095-.257-.233zm7.062-12.098c2.047-.478 4.805.28 6.091 1.179-1.494-1.997-5.23-5.708-7.432-6.882 1.156 1.168 1.563 4.235 1.341 5.703zm-4.769 10.21c.328-.109 1.036-.274 1.213-.315-.02-.021-.528-.544-.695-.832-.134.335-.509 1.127-.518 1.147zm.64-4.008c-.057-.278-.263-.299-.326.024-.057.296.029.771.129 1.061.113-.237.255-.805.197-1.085zm10.22-.979v13h-20v-24h8.409c4.857 0 3.335 8 3.335 8 3.009-.745 8.256-.42 8.256 3zm-6.98 4.413c-.526-.077-1.272.009-1.797.093-.385-.325-.866-.817-1.233-1.472.253-.652.415-1.168.483-1.536.354-1.919-1.979-2.072-1.729-.012.066.549.222 1.082.464 1.588-.286.709-.651 1.508-1.018 2.232-.811.307-1.396.627-1.742.954-1.212 1.143.295 2.661 1.438 1.014.274-.395.581-.955.811-1.396.717-.253 1.551-.475 2.33-.618.509.39 1.322.896 1.972.896 1.239.001 1.417-1.538.021-1.743zm-.104.704c-.2-.03-.488-.03-.829-.002.235.158.558.323.911.33.412.008.377-.26-.082-.328z"/></svg>
      </div>

      <div class="pdf__content">
        <div class="pdf__row">
          <div class="pdf__icon pdf__icon--md">
            <svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" viewBox="0 0 24 24"><path d="M11.239 7.237c-.004-.009-.288-.017-.24-.078l.137-.085c.013-.077.072-.162-.007-.304l.047-.125-.1.029s.141-.606.33-.332l-.08.093c.122.122.155.426.195.623.115.06.294.071.088.175.106-.018-.561.286-.648.161-.065-.076.288-.127.278-.157zm-.715-.159c-.077.078.003.128.082.094.114-.05.269-.048.284-.202l.073-.091-.101-.135c-.06-.012-.1.064-.137.095l-.066.017-.062.08.007.044-.08.098zm7 9.167l-.733-1.206-.724-1.186c-.73-1.194-1.388-2.276-1.961-3.296l-.07.067c-.376.156-.942-.509-1.339-.531.192.03.018-.49.018-.524-.153-.189-1.123.021-1.378.055-.479.063-.979.057-1.346.355-.258.21-.262.551-.524.716-.17.106-.356.072-.502.209-.258.245-.553.607-.697.929-.062.135.077.458.043.632-.336 1.063.085 2.538 1.375 2.701.312.039.638.209.955.114.252-.076.474-.248.745-.268.377-.025.22.529.737.379.251-.074.365.172.365.359-.084.391-.268.609.088.883.242.188.442.456.486.78.026.182.196.494-.015.602-.149.075-.259.507-.257.649.031.165.365.481.466.621.146.2.039.436.158.663.122.232.237.41.323.645.111.324.958-.007 1.156-.006.673.004 1.014-.944 1.487-1.235.267-.165.192-.616.51-.848.296-.215.608-.344.636-.741.021-.344-.259-1.062-.104-1.353l.102-.165zm-7.301-7.76c.041.172-.119.645-.154.795-.031.138.442.226.415.295.004-.008.642-.22.705-.275l.144-.323c.121-.081.248-.146.384-.196l.164-.285c.056-.021.71-.123.756-.101.165.075.469.389.583.531l.041.032c-.326-.67-.59-1.314-.796-1.942l-.083.036c-.222 0-.528.251-.663.405-.095.104-.669.337-.732.33.33.035.314.276.288.482-.068.476-1.096.035-1.052.216zm10.904 5.049c-.277 4.807-4.253 8.623-9.13 8.623-2.603 0-4.951-1.086-6.618-2.83-.198-.208-.346-.7-.02-.9l.331-.085c.259-.22-.242-1.111-.044-1.254.617-.441.324-.982-.055-1.429-.161-.19-1.043-1.1-1.143-.937.074-.249-.16-.85-.302-1.087-.239-.398-.553-.643-.679-1.081-.05-.174-.05-.704-.153-.826-.041-.05-.358-.185-.347-.257.305-1.82 1.147-3.458 2.364-4.751l.821-.33c.515-.773.545-.173 1.008-.375.154 0 .331-.634.496-.734.289-.185.068-.185.015-.27-.112-.184 2.411-1.103 2.453-.938.034.14-1.249.809-1.108.788-.326.043-.388.627-.328.625.163-.005 1.182-.774 1.657-.61.466.161 1.301-.37 1.627-.64l.04-.038c.029-.761.195-1.494.481-2.172l-.493-.026c-6.075 0-11 4.925-11 11s4.925 11 11 11c6.074 0 11-4.925 11-11 0-.764-.078-1.509-.227-2.229-.491.864-1.044 1.779-1.646 2.763zm1.873-9.1c0 2.45-1.951 5.373-4.5 9.566-2.549-4.193-4.5-7.116-4.5-9.566 0-2.449 2.139-4.434 4.5-4.434s4.5 1.985 4.5 4.434zm-2.75.066c0-.966-.784-1.75-1.75-1.75s-1.75.784-1.75 1.75.784 1.75 1.75 1.75 1.75-.784 1.75-1.75z"/></svg>
          </div>
          <div class="pdf__text">
            <p>{{ result.attributes && result.attributes.locations[0] && result.attributes.locations[0].attributes.name ? result.attributes.locations[0].attributes.name : 'Unknown' }}</p>
          </div>
        </div>

        <div class="pdf__row">
          <div class="pdf__icon pdf__icon--md">
            <svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" viewBox="0 0 24 24"><path d="M20 9.352c0-4.852-4.75-8.352-10-8.352-5.281 0-10 3.527-10 8.352 0 1.71.615 3.39 1.705 4.695.047 1.527-.85 3.719-1.66 5.312 2.168-.391 5.252-1.258 6.648-2.115 7.698 1.877 13.307-2.842 13.307-7.892zm-14.5 1.381c-.689 0-1.25-.56-1.25-1.25s.561-1.25 1.25-1.25 1.25.56 1.25 1.25-.561 1.25-1.25 1.25zm4.5 0c-.689 0-1.25-.56-1.25-1.25s.561-1.25 1.25-1.25 1.25.56 1.25 1.25-.561 1.25-1.25 1.25zm4.5 0c-.689 0-1.25-.56-1.25-1.25s.561-1.25 1.25-1.25 1.25.56 1.25 1.25-.561 1.25-1.25 1.25zm7.036 1.441c-.161.488-.361.961-.601 1.416 1.677 1.262 2.257 3.226.464 5.365-.021.745-.049 1.049.138 1.865-.892-.307-.979-.392-1.665-.813-2.127.519-4.265.696-6.089-.855-.562.159-1.145.278-1.74.364 1.513 1.877 4.298 2.897 7.577 2.1.914.561 2.933 1.127 4.352 1.385-.53-1.045-1.117-2.479-1.088-3.479 1.755-2.098 1.543-5.436-1.348-7.348z"/></svg>
          </div>
          <div class="pdf__text">
            <p>{{ result.attributes && result.attributes.topics[0] && result.attributes.topics[0].attributes.name ? result.attributes.topics[0].attributes.name : 'Unknown' }}</p>
          </div>
        </div>

        <!--<div class="pdf__row">
          <div class="pdf__icon pdf__icon--md">
            <svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" viewBox="0 0 24 24" fill-rule="evenodd" clip-rule="evenodd"><path d="M24 11.374c0 4.55-3.783 6.96-7.146 6.796-.151 1.448.061 2.642.384 3.641l-3.72 1.189c-.338-1.129-.993-3.822-2.752-5.279-2.728.802-4.969-.646-5.784-2.627-2.833.046-4.982-1.836-4.982-4.553 0-4.199 4.604-9.541 11.99-9.541 7.532 0 12.01 5.377 12.01 10.374zm-21.992-1.069c-.145 2.352 2.179 3.07 4.44 2.826.336 2.429 2.806 3.279 4.652 2.396 1.551.74 2.747 2.37 3.729 4.967l.002.006.111-.036c-.219-1.579-.09-3.324.36-4.528 3.907.686 6.849-1.153 6.69-4.828-.166-3.829-3.657-8.011-9.843-8.109-6.302-.041-9.957 4.255-10.141 7.306zm8.165-2.484c-.692-.314-1.173-1.012-1.173-1.821 0-1.104.896-2 2-2s2 .896 2 2c0 .26-.05.509-.141.738 1.215.911 2.405 1.855 3.6 2.794.424-.333.96-.532 1.541-.532 1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5c-1.171 0-2.155-.807-2.426-1.895-1.201.098-2.404.173-3.606.254-.17.933-.987 1.641-1.968 1.641-1.104 0-2-.896-2-2 0-1.033.784-1.884 1.79-1.989.12-.731.252-1.46.383-2.19zm2.059-.246c-.296.232-.66.383-1.057.417l-.363 2.18c.504.224.898.651 1.079 1.177l3.648-.289c.047-.267.137-.519.262-.749l-3.569-2.736z"/></svg>
          </div>
          <div class="pdf__text">
            <p>{{ result.attributes && result.attributes.providers[0] && result.attributes.providers[0].attributes.name ? result.attributes.providers[0].attributes.name : 'Unknown' }}</p>
          </div>
        </div>-->
      </div>
    </div>

     <!--<div class="pdf__description">
      <p v-html="result.attributes && result.attributes.short_description ? highlight(result.attributes.short_description, filterWords) : 'Document available for licensed users.'" />
    </div>

   <div
      class="pdf__meta"
      v-html="formatMeta(result.attributes && result.attributes.meta ? result.attributes.meta : false)"
    />-->
  </div>
</template>

<script>
import helperMethods from '@/helpers/utility.js'

export default {
  props: {
    result: {
      type: Object,
      default: function () {
        return {}
      }
    },
    size: {
      type: String,
      default: 'sm'
    },
    height: {
      type: [Number, String],
      default: ''
    },
    windowWidth: {
      type: [Number, String],
      default: ''
    }
  },
  computed: {
    filterWords () {
      let words = []
      let getter = this.$store.getters['search/getSelectedFilters']

      Object.keys(getter).forEach(function (filters) {
        if (getter[filters] && getter[filters].length > 0) {
          getter[filters].forEach(function (filter) {
            words.push(filter.attributes.name)
          })
        }
      })

      return words
    }
  },
  methods: {
    formatMeta (content) {
      if (content !== false) {
        let result = []

        for (const [key, value] of Object.entries(JSON.parse(content))) {
          result.push('<p><span>' + key + '</span>: ' + value + '</p>')
        }

        return result.join('')
      }

      return content
    },
    ...helperMethods
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.pdf {
  @include font('content--md', $white, 1);
  display: flex;
  //justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  cursor: pointer;
  padding: 0px 12px;

  &__header {
    display: flex;
    align-items: center;
    width: 100%;
    height: 64px;
  }

  /*&__logo {
    fill: rgba($red, 0.6);
    transition: fill 0.2s ease-out;
    width: 64px;
    min-width: 64px;
    max-width: 64px;
    height: 64px;
    margin-right: 16px;
  }*/

  &__logo {
    width: 38px;
    min-width: 38px;
    max-width: 38px;
    height: 38px;
    fill: rgba($white, 0.9);
    background-color: rgba($red, 0.75);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    padding: 10px;
    margin: 0px 16px 0px 0px;
    box-shadow: 0 2px 1px -1px rgba($black, 0.5), 0 1px 1px 0 rgba($black, 0.5), 0 1px 3px 0 rgba($black, 0.25);
    border-radius: 4px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    width: calc(100% - 80px);
  }

  &__description {
    width: 100%;

    p {
      overflow: hidden;
      display: -webkit-box;
      text-overflow: ellipsis;
      line-clamp: 3;
      -webkit-box-orient: vertical;
      color: rgba($white, 0.7);
    }
  }

  &__row {
    display: flex;
    align-items: center;

    p {
      color: rgba($white, 0.9);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0.1rem 0;
    }
  }

  &__icon {
    fill: rgba($white, 0.5);

    &--md {
      width: 16px;
      min-width: 16px;
      height: 16px;
      margin-right: 10px;

      @media screen and (min-width: $breakpointLg) {
        width: 18px;
        height: 18px;
      }
    }

    &--lg {
      width: 18px;
      min-width: 18px;
      height: 18px;
      margin-right: 8px;

      @media screen and (min-width: $breakpointLg) {
        width: 20px;
        height: 20px;
      }
    }
  }

  &__text {
    width: calc(100% - 26px);
  }
}

</style>
